import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import styles from "./PatchNoteModal.module.css";

const PatchNoteModal = ({ onClose }) => {
  const { t, language } = useLanguage();

  const patchNotes = {
    ko: [
      {
        version: "1.6.0",
        date: "2026.09.05",
        changes: ["단어추리왕 게임 추가"],
      },
      {
        version: "1.5.0",
        date: "2026.05.09",
        changes: ["빠른 산수 챌린지게임 추가","2048 광고보고 다시하기 기능 추가", "스도쿠 최적화"],
      },
      {
        version: "1.4.0",
        date: "2025.04.09",
        changes: ["파닥파닥 게임 출시"],
      },
      {
        version: "1.3.8",
        date: "2025.04.06",
        changes: ["이스터 에그 추가"],
      },
      {
        version: "1.3.7",
        date: "2025.02.26",
        changes: ["청포도 10 난이도 10단계 추가", "Sudoku BGM 추가"],
      },
      {
        version: "1.3.6",
        date: "2025.02.20",
        changes: ["BGM 플레이어 위젯으로 변경", "청포도 10 빈칸도 터치되도록 수정"],
      },
      {
        version: "1.3.5",
        date: "2025.02.19",
        changes: ["청포도 10 난이도 9단계 추가"],
      },
      {
        version: "1.3.4",
        date: "2025.02.17",
        changes: ["2048 타일 상한 4096까지 확장\n2048 클리어 애쉬 쟈니 옌 제이"],
      },
      {
        version: "1.3.3",
        date: "2025.02.16",
        changes: ["청포도 10 제한시간 UI 게임보드 아래에도 표시", "2048 Safari 브라우저 호환성 개선"],
      },
      {
        version: "1.3.2",
        date: "2025.02.14",
        changes: ["청포도 10 게임로직 변경\n(포도알 재출현, 입력 시간 규칙 추가)\n기획 쟈니", "BGM이 백그라운드에서 실행되던 문제 수정"],
      },
      {
        version: "1.3.1",
        date: "2025.02.12",
        changes: ["2048 디자인 업데이트\n디자인 유니"],
      },
      {
        version: "1.3.0",
        date: "2025.02.10",
        changes: ["청포도 10 게임 출시"],
      },
      {
        version: "1.2.0",
        date: "2025.02.08",
        changes: ["2048 게임 출시"],
      },
      {
        version: "1.1.0",
        date: "2025.02.06",
        changes: ["보석 합치기 게임 출시", "오늘도 스도쿠 난이도 9까지 확장"],
      },
      {
        version: "1.0.0",
        date: "2025.01.31",
        changes: ["Everyday Games 웹사이트 오픈", "오늘도 스도쿠 게임 출시"],
      },
    ],
    en: [
      {
        version: "1.6.0",
        date: "2026.09.05",
        changes: ["Add Word Master game"],
      },
      {
        version: "1.5.0",
        date: "2026.05.09",
        changes: ["Add Speed Math game","2048 Additional Replay Feature","Sudoku Optimization"],
      },
      {
        version: "1.4.0",
        date: "2025.04.09",
        changes: ["Released FlapFlap game"],
      },
      {
        version: "1.3.8",
        date: "2025.04.06",
        changes: ["Added Easter egg"],
      },
      {
        version: "1.3.7",
        date: "2025.02.26",
        changes: [
          "Added level 10 difficulty to Grape 10",
          "Added Sudoku BGM"
        ],
      },
      {
        version: "1.3.6",
        date: "2025.02.20",
        changes: ["Changed BGM player to widget", "Modified Grape 10 to allow empty cell selection"],
      },
      {
        version: "1.3.5",
        date: "2025.02.19",
        changes: ["Added level 9 difficulty to Grape 10"],
      },
      {
        version: "1.3.4",
        date: "2025.02.17",
        changes: ["Extended 2048 tile limit to 4096\n2048 cleared by Ash, Zanni, Yen, Jay"],
      },
      {
        version: "1.3.3",
        date: "2025.02.16",
        changes: [
          "Added timer UI below the game board in Grape 10",
          "Improved Safari browser compatibility for 2048"
        ],
      },
      {
        version: "1.3.2",
        date: "2025.02.14",
        changes: [
          "Updated Grape 10 game logic\n(Grape respawn, Added input time rule)\nPlanned by Zanni",
          "Fixed BGM playing in background issue"
        ],
      },
      {
        version: "1.3.1",
        date: "2025.02.12",
        changes: ["2048 design update\nDesign by Yooni"],
      },
      {
        version: "1.3.0",
        date: "2025.02.10",
        changes: ["Released Grape 10 game"],
      },
      {
        version: "1.2.0",
        date: "2025.02.08",
        changes: ["Released 2048 game"],
      },
      {
        version: "1.1.0",
        date: "2025.02.06",
        changes: [
          "Released Raising gems game",
          "Extended Sudoku difficulty up to level 9"
        ],
      },
      {
        version: "1.0.0",
        date: "2025.01.31",
        changes: [
          "Launched Everyday Games website",
          "Released Daily Sudoku game"
        ],
      },
    ],
  };

  return (
    <div className="modal-overlay">
      <div className={`modal ${styles.patchNoteModal}`}>
        <h2>{t("patchNotes")}</h2>
        <div className={styles.patchNoteContent}>
          {patchNotes[language].map((patch, index) => (
            <div key={index} className={styles.patchNote}>
              <div className={styles.patchHeader}>
                <span className={styles.version}>v{patch.version}</span>
                <span className={styles.date}>{patch.date}</span>
              </div>
              <ul>
                {patch.changes.map((change, changeIndex) => (
                  <li key={changeIndex}>{change}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="modal-buttons">
          <button onClick={onClose}>{t("close")}</button>
        </div>
      </div>
    </div>
  );
};

export default PatchNoteModal;
